import React from 'react';

interface ProfileData {
  fullName: string;
  phone: string;
  profileImage: File | null;
  profileImageUrl?: string;
  businessName: string;
  licenseNumber: string;
  yearsOfExperience: number;
  bio: string;
  address: string;
  city: string;
  state: string;
  zipCode: string;
  website: string;
  specialties: string[];
  services: string[];
  treatmentCategories: string[];
  pricingRange: string;
  virtualConsultations: boolean;
  education: Array<{
    degree: string[];
    institution: string;
    year: string;
  }>;
  certifications: Array<{
    name: string[];
    issuer: string;
    year: string;
  }>;
  affiliations: string[];
  insuranceAccepted: string[];
  languagesSpoken: string[];
}

interface Step3ServicesProps {
  data: ProfileData;
  updateData: (updates: Partial<ProfileData>) => void;
}

const Step3Services: React.FC<Step3ServicesProps> = ({ data, updateData }) => {
  // Unified services list - merged from previous "Specialties" and "Treatment Categories"
  const servicesOptions = [
    // Specific treatments
    'Neurotoxin',
    'Neuromodulator',
    'Fillers',
    'Hyaluronic Acid Filler',
    'Biostimulatory Injectables',
    'Regenerative / Biologic Adjunct',
    'Injectables (Neurotoxin, Fillers)',
    'Laser Treatments',
    'Chemical Peels',
    'Microneedling',
    'Body Contouring',
    'Body Sculpting',
    'Skin Rejuvenation',
    'Hair Restoration',
    'Hair Treatment',
    'Acne Treatment',
    'Medical Grade Skincare',
    // Wellness and categories
    'Anti-Aging',
    'Facial Aesthetics',
    'Skin Care',
    'Wellness Treatments',
    'Wellness',
    'Surgery',
    'Other',
  ];

  const toggleService = (service: string) => {
    const updated = data.services.includes(service)
      ? data.services.filter((s) => s !== service)
      : [...data.services, service];
    updateData({ services: updated });
  };

  return (
    <div className="space-y-4 sm:space-y-6">
      <h2 className="font-['Ovo',_serif] text-[22px] sm:text-[26px] lg:text-[28px] text-[#1f1f1f] mb-4 sm:mb-6">
        What services do you offer?
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {servicesOptions.map((service) => (
          <label key={service} className="flex items-center gap-3 cursor-pointer min-h-[44px] py-1">
            <input
              type="checkbox"
              checked={data.services.includes(service)}
              onChange={() => toggleService(service)}
              className="w-5 h-5 text-[#c6a664] focus:ring-[#c6a664] flex-shrink-0"
            />
            <span className="font-['Open_Sans'] text-sm text-[#1f1f1f]">{service}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default Step3Services;
